import { getPolicyPdfDownloadUrl, getQuotePdfDownloadUrl } from "@/config/api";
import { requirePartnerAuthHeaders } from "@/utils/partnerAuth";

export interface FetchQuotePdfParams {
  idCotizacion: number | string;
  formaPago?: string;
  paquete?: string;
  cia?: number | null;
}

/** GET PDF con headers partner (x-partner-id / x-partner-apikey). */
const fetchPartnerPdfBlob = async (pdfUrl: string): Promise<Blob> => {
  const partnerHeaders = requirePartnerAuthHeaders();
  const response = await fetch(pdfUrl, {
    method: "GET",
    headers: partnerHeaders,
  });

  if (!response.ok) {
    throw new Error(
      `Error al descargar PDF: ${response.status} ${response.statusText}`,
    );
  }

  return response.blob();
};

/** GET PDF cotización con headers partner (sin ?token=). */
export const fetchQuotePdfBlob = (params: FetchQuotePdfParams): Promise<Blob> =>
  fetchPartnerPdfBlob(getQuotePdfDownloadUrl(params));

/** GET PDF póliza con headers partner. */
export const fetchPolicyPdfBlob = (idPoliza: number | string): Promise<Blob> =>
  fetchPartnerPdfBlob(getPolicyPdfDownloadUrl(idPoliza));

export const triggerBlobDownload = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.style.position = "fixed";
  link.style.left = "-9999px";
  link.style.opacity = "0";
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, 100);
};
